/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var IndesignIcon = createIcon("IndesignIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#49021F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.406 34V13.756h-3.402V34h3.402Zm9.464.28c3.094 0 4.312-1.862 4.76-3.248L32.008 34h2.52V13.196h-3.43v8.442c-.588-1.106-2.156-2.394-4.536-2.394-3.822 0-5.838 2.926-5.838 7.448 0 4.858 2.31 7.588 6.146 7.588Zm.7-2.506c-2.212 0-3.472-1.764-3.472-5.166 0-3.416 1.456-4.83 3.514-4.83 2.408 0 3.458 1.68 3.486 4.83 0 3.696-1.078 5.166-3.528 5.166Z",
    fill: "#F36"
  }));
}, {
  "i18nKey": "svg.IndesignIcon"
});